import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  institutionData: [],
  termDepositData: [],
  uniqueAccountManager: [],
  termDepositDetailsData: [],
  termDepositSendReminderData:[],
  termdepositId:'',
  newlyAddedCount:0,
};

const TermDepositSlice = createSlice({
  name: "TermDepositSlice",
  initialState,
  reducers: {
    setInstituionData: (state, action) => {
      state.institutionData = action.payload;
    },
    setTermDepositData: (state, action) => {
      state.termDepositData = action.payload;
    },
    setUniqueAccountmanager: (state, action) => {
      state.uniqueAccountManager = action.payload;
    },
    setTermDepositDetailsData: (state, action) => {
      state.termDepositDetailsData = action.payload;
    },
    setTermDepositSendReminderData: (state, action) => {
      state.termDepositSendReminderData = action.payload;
    },
    setTermDepositId: (state, action) => {
      state.termdepositId = action.payload;
    },
    setNewlyAddedCount: (state, action) => {
      state.newlyAddedCount = action.payload;
    }
  },
});
export const {
  setInstituionData,
  setTermDepositData,
  setUniqueAccountmanager,
  setTermDepositDetailsData,
  setTermDepositSendReminderData,
  setTermDepositId,
  setNewlyAddedCount
} = TermDepositSlice.actions;

export default TermDepositSlice.reducer;
